import React from 'react';
import { SEO_SITE_URL } from '../seo/seoData';

// Phase C1A + OG Phase 2 — per-route metadata via React 19 native render-time hoisting.
// Emits: <title>, <meta name="description">, canonical OR robots(noindex), AND the per-route
// Open Graph + Twitter tags. OG ownership is centralized here; the per-route image is the route's
// own `ogImage` from seoData (the single source of truth), with og-default.png as the fallback.
// The previous static global OG block in index.html is removed, so each page has EXACTLY ONE
// og:image / twitter:image (React 19 does not deduplicate — a single emitter avoids duplicates).
const OG_FALLBACK = '/og-default.png';
const absUrl = (p) => (p && p.startsWith('http') ? p : `${SEO_SITE_URL}${p}`);

export default function Seo({ title, description, canonical, ogImage, noindex = false }) {
  const image = absUrl(ogImage || OG_FALLBACK);
  return (
    <>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      {noindex
        ? <meta name="robots" content="noindex,nofollow" />
        : (canonical ? <link rel="canonical" href={canonical} /> : null)}

      {/* Open Graph (per-route; image + url/title/description derive from the route's seoData) */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Black Matte" />
      {title ? <meta property="og:title" content={title} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="fr_FR" />

      {/* Twitter card (mirrors OG; single emitter) */}
      <meta name="twitter:card" content="summary_large_image" />
      {title ? <meta name="twitter:title" content={title} /> : null}
      {description ? <meta name="twitter:description" content={description} /> : null}
      <meta name="twitter:image" content={image} />
    </>
  );
}
